import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
};

export const bugReportSlice = createSlice({
  name: "bugReport",
  initialState,
  reducers: {
    openBugReport: (state) => {
      state.isOpen = true;
    },
    closeBugReport: (state) => {
      state.isOpen = false;
    },
    toggleBugReport: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openBugReport, closeBugReport, toggleBugReport } =
  bugReportSlice.actions;

export const selectIsBugReportOpen = (state) => state.bugReport.isOpen;

export default bugReportSlice.reducer;
